import PropertyCompareTransitionWrapper from './property-compare-transition-wrapper'

export default PropertyCompareTransitionWrapper
